import { StylesPropI } from 'interfaces';
import { css, styled } from 'styled-components';

const GenericContainer = styled('div')<{ $width?: string; $styles?: StylesPropI; $padding?: boolean }>(
  ({ theme, $styles, $width, $padding = true }) => css`
    width: ${$width || '80rem'};
    max-width: 100%;

    @media (max-width: 90rem) {
      padding: ${$padding && '0 5rem'};
      max-width: 100%;
    }

    @media (max-width: ${theme.breakpoints.lg}) {
      padding: ${$padding && '0 3rem'};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: ${$padding && '0 1rem'};
    }

    ${$styles && $styles};

    @media (min-width: 1920px) {
      width: 1340px;
      margin: 0 auto;
      padding: 0;
    }
  `
);

export default GenericContainer;
